const UNIT_I18N_KEYS: Record<string, string> = {
  Knots: "units.knots",
  "km/h": "units.kmh",
  mph: "units.mph",
  "m/s": "units.ms",
  Kilometers: "units.kilometers",
  "N.Miles": "units.nauticalMiles",
  Miles: "units.miles"
};

export type TranslateFn = (key: string) => string;

export interface UnitOption {
  value: string;
  label?: string;
  [key: string]: any;
}

export const getLocalizedUnit = (unit: string | null | undefined, t?: TranslateFn): string => {
  const key = UNIT_I18N_KEYS[unit];
  if (!key) return unit ?? "";
  return t ? t(key) : (unit ?? "");
};

export const getLocalizedUnitOptions = (options: UnitOption[], t?: TranslateFn): UnitOption[] =>
  options.map((option) => ({...option, label: getLocalizedUnit(option.value, t)}));
